<template>
  <b-col>
    <b-row>
      <b-col><h2>Сменить пароль</h2></b-col>
    </b-row>
    <b-row>
      <ValidationObserver v-slot="{ valid }">
        <b-form @submit="changePassword" class="mt-3 col-12">
          <validation-provider
            name="Новый пароль"
            :rules="'verify_password|required'"
            v-slot="{ dirty, valid, invalid, errors }"
          >
            <b-form-row class="mb-1">
              <b-col
                ><label class="mr-sm-2" for="password-profile"
                  >Новый пароль</label
                ></b-col
              >
              <b-col>
                <b-input-group>
                  <b-form-input
                    id="password-profile"
                    v-model="password"
                    v-bind:type="show_password ? 'text' : 'password'"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }"
                  ></b-form-input
                  ><b-input-group-append>
                    <b-button
                      @click="show_password = !show_password"
                      variant="outline-primary"
                      size="sm"
                      ><i
                        v-if="!show_password"
                        class="hp-text-color-dark-0 iconly-Light-Show"
                      ></i>
                      <i
                        v-else
                        class="hp-text-color-dark-0 iconly-Light-Hide"
                      ></i>
                    </b-button>
                    <b-button
                      @click="password = gen_password(20)"
                      variant="outline-primary"
                      size="sm"
                      ><i class="hp-text-color-dark-0 iconly-Light-Password"></i
                    ></b-button> </b-input-group-append
                ></b-input-group>
              </b-col>
            </b-form-row>
          </validation-provider>
          <validation-provider
            name="Подтверждение пароля"
            :rules="'verify_password|required'"
            v-slot="{ dirty, valid, invalid, errors }"
          >
          <b-form-row class="mb-1">
            <b-col
              ><label class="mr-sm-2" for="confirm-password-profile"
                >Подтверждение пароля</label
              ></b-col
            >
            <b-col
              ><b-input-group
                ><b-form-input
                  id="confirm-password-profile"
                  v-model="confirm_password"
                  v-bind:type="show_confirm_password ? 'text' : 'password'"
                  v-bind:class="{
                    'is-valid': dirty && valid,
                    'is-invalid': dirty && invalid,
                  }"
                  required
                ></b-form-input
                ><b-input-group-append>
                  <b-button
                    @click="show_confirm_password = !show_confirm_password"
                    variant="outline-primary"
                    size="sm"
                    ><i
                      v-if="!show_confirm_password"
                      class="hp-text-color-dark-0 iconly-Light-Show"
                    ></i>
                    <i
                      v-else
                      class="hp-text-color-dark-0 iconly-Light-Hide"
                    ></i>
                  </b-button> </b-input-group-append></b-input-group
            ></b-col>
          </b-form-row>
          </validation-provider>

          <b-button :disabled="!valid" variant="outline-primary" type="submit"
            >Сохранить</b-button
          >
        </b-form>
      </ValidationObserver>
    </b-row>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BAvatar,
  BButton,
  BLink,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BForm,
  BFormRow,
} from "bootstrap-vue";

import axios from "axios";
import { sha512 } from "js-sha512";

export default {
  data() {
    return {
      password: "",
      confirm_password: "",

      show_password: false,
      show_confirm_password: false,
    };
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BButton,
    BLink,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BForm,
    BFormRow,
  },
  methods: {
    logout() {
      localStorage.setItem("token", "");
      this.$router.push({ path: "/pages/authentication/login" });
    },
    changePassword(event) {
      event.preventDefault();
      if (this.password != this.confirm_password) {
        alert("Пароли не совпали");
        return;
      }
      axios
        .post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/profile/update`,
          {
            password: sha512(this.password),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    gen_password(len) {
      var password = "";
      var upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var cntUpper = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntUpper; i++) {
        password += upperCase.charAt(
          Math.floor(Math.random() * upperCase.length)
        );
      }

      var lowerCase = "abcdefghijklmnopqrstuvwxyz";
      var cntLower = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntLower; i++) {
        password += lowerCase.charAt(
          Math.floor(Math.random() * lowerCase.length)
        );
      }

      var numbers = "0123456789";
      var cntNumber = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntNumber; i++) {
        password += numbers.charAt(Math.floor(Math.random() * numbers.length));
      }

      var specSymbols = "!@#$%^&*";
      var cntSpec = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntSpec; i++) {
        password += specSymbols.charAt(
          Math.floor(Math.random() * specSymbols.length)
        );
      }
      var shuffled_password = password
        .split("")
        .sort(function () {
          return 0.5 - Math.random();
        })
        .join("");

      var symbols =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";

      while (shuffled_password.length < len) {
        shuffled_password += symbols.charAt(
          Math.floor(Math.random() * symbols.length)
        );
      }
      return shuffled_password;
    },
  },
};
</script>
